import moment from "moment/moment";
import {SHIFT_SELECTION_STATUS} from "../domain/ShiftPlanConstants";

export const BOOKABLE_STATUS = {
    BOOKABLE: 'Bookable',
    UNBOOKABLE: 'Unbookable'
};

export const hasSelectedTimeblocks = (shiftPlans) => {
    if (!shiftPlans || shiftPlans.length === 0) {
        return false;
    }
    
    const firstShiftPlan = shiftPlans[0];
    if (!firstShiftPlan.enrollments) {
        return false;
    }
    
    return firstShiftPlan.enrollments.some(enrollment => 
        enrollment.shiftSelectionStatus === SHIFT_SELECTION_STATUS.SELECTED && enrollment.availability === null
    );
};

export const hasNewlySelectedTimeblocks = (shiftPlans) => {
    if (!shiftPlans || shiftPlans.length === 0) {
        return false;
    }

    const firstShiftPlan = shiftPlans[0];
    if (!firstShiftPlan.enrollments) {
        return false;
    }

    return firstShiftPlan.enrollments.some(enrollment => {
        if (enrollment.availability === null) {
            return false;
        }

        const performingFrom = moment(enrollment.availability?.performingFrom);
        const performingTo = moment(enrollment.availability?.to);
        const approvedFrom = moment(enrollment.approvedFromTime);
        const approvedTo = moment(enrollment.approvedToTime);

        return performingFrom.isAfter(approvedFrom) || performingTo.isBefore(approvedTo);
    });
};